import script from "./notifications.vue?vue&type=script&setup=true&lang=js"
export * from "./notifications.vue?vue&type=script&setup=true&lang=js"

import "./notifications.vue?vue&type=style&index=0&id=5ca413f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca413f6"]])

export default __exports__